import * as React from 'react';
import { NumericFormat, NumericFormatProps, SourceInfo } from 'react-number-format';

export interface NumberFormatCustomOnChange {
  target: { value: number | null };
}

const NumberFormatCustom = React.forwardRef<
  any,
  NumericFormatProps & {
    onChange: (params: NumberFormatCustomOnChange, event: SourceInfo['event']) => void;
  }
>(
  (
    {
      onChange,
      decimalScale = 2,
      thousandSeparator = '.',
      decimalSeparator = ',',
      allowNegative = false,
      max = 999999999.99,
      ...rest
    },
    ref,
  ) => (
    <NumericFormat
      {...rest}
      getInputRef={ref}
      onValueChange={(values, sourceInfo) => {
        onChange?.(
          {
            target: {
              value: values.value && values.value !== '' ? Number(values.value) : null,
            },
          },
          sourceInfo.event,
        );
      }}
      valueIsNumericString
      allowNegative={allowNegative}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      isAllowed={(values) => {
        const { formattedValue, floatValue } = values;
        return formattedValue === '' || (floatValue ?? 0) <= Number(max);
      }}
    />
  ),
);

export default NumberFormatCustom;
